import React from 'react';
import { amountDisplay, isDarkModeOn } from '../../util/helper';
import { useLanguage } from '../../context/LanguageContext';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

const CategoryExpenseBox = ({ expense, currentMonth, reportingType = 'monthly' }) => {
    const { language, t } = useLanguage();

    const currentPeriodObj = currentMonth ? dayjs(currentMonth) : dayjs();
    const isYearly = reportingType === 'yearly';
    const isCurrentMonth = currentPeriodObj.isSame(dayjs(), 'month');
    const shouldAttachRange = isYearly || !isCurrentMonth;
    const periodStartDate = currentPeriodObj
        .startOf(isYearly ? 'year' : 'month')
        .format('YYYY-MM-DD');
    const periodEndDate = currentPeriodObj.endOf(isYearly ? 'year' : 'month').format('YYYY-MM-DD');

    return (
        <>
            <Link
                to="/transaction-history"
                state={{
                    selectedCategoryId: expense.category_id,
                    selectedCategoryName: expense.category_name,
                    periodType: isYearly ? 'year' : 'month',
                    reportingType,
                    ...(shouldAttachRange && {
                        startDate: periodStartDate,
                        endDate: periodEndDate,
                    }),
                }}
            >
                <div className="saving-plan-box p-10">
                    <h3>{expense.category_name}</h3>
                    <h6>{t('expense')}</h6>
                    <div
                        className="progress"
                        role="progressbar"
                        aria-label="progressbar"
                        aria-valuenow={expense.progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        <div
                            className={`progress-bar bg-danger`}
                            style={{ width: `${expense.progress}%` }}
                        ></div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <h5 className="theme-color">
                            {amountDisplay(expense.total_amount, language)}
                        </h5>
                        <img
                            className="img-fluid arrow"
                            src={
                                isDarkModeOn()
                                    ? '/assets/images/svg/arrow-white.svg'
                                    : '/assets/images/svg/arrow.svg'
                            }
                            alt="arrow"
                        />
                    </div>
                </div>
            </Link>
        </>
    );
};

export default CategoryExpenseBox;
